import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Info(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12.5 9a2 2 0 100-4 2 2 0 000 4zm.09 9.81c.36-.13.84-.31 1.45-.55l.21-.82a3.3 3.3 0 01-.51.17c-.24.07-.44.1-.63.1-.39 0-.67-.06-.83-.19-.16-.13-.24-.37-.24-.73 0-.14.02-.36.07-.63.05-.28.11-.52.17-.74l.73-2.08c.07-.25.12-.51.15-.81.03-.3.04-.5.04-.62 0-.57-.19-1.03-.59-1.38-.39-.35-.96-.53-1.69-.53-.4 0-.84.07-1.29.22-.45.14-.93.32-1.43.52l-.2.83c.15-.06.33-.12.53-.18.21-.06.41-.09.61-.09.4 0 .67.06.81.2s.21.38.21.72c0 .19-.02.4-.07.63l-.018.084c-.044.205-.09.418-.152.646l-.73 2.09c-.07.28-.12.53-.14.76-.03.23-.05.44-.05.66 0 .56.2 1.01.61 1.37.41.36.98.54 1.72.54.48 0 .9-.06 1.26-.19z",
    clipRule: "evenodd"
  }));
}

export default Info;